export const ROUTES = {
  LOGIN: '/',
  LOGIN_VALIDATION: '/valida-login',
  TERMS_OF_USE_AND_CONFIDENTIALITY: '/termo',
  HOME: '/painel',
  MENU_USER: '/menu-usuario',
  MANAGE_USER: '/usuarios',
  USER_CREATE: '/usuarios/cadastrar',
  USER_EDIT: '/usuarios/editar/:uuid',
  USER_VIEW: '/usuarios/visualizar/:uuid',
  INSTITUTION: '/instituicoes',
  INSTITUTION_VIEW: '/instituicoes/visualizar/:uuid',
  INSTITUTION_EDIT: '/instituicoes/editar/:uuid',
  CICAAF: '/cicaaf/homeCicaaf/',
  CUFFA: '/cuffa',
  MANAGE_PROFILES: '/perfis',
  PROFILES_CREATE: '/perfis/cadastrar',
  MANAGE_PERMISSIONS: '/permissoes',
  PERMISSIONS_CREATE: '/permissoes/cadastrar',
  PERMISSIONS_EDIT: '/permissoes/editar/:uuid',
  PERMISSIONS_VIEW: '/permissoes/visualizar/:uuid',
  MANAGE_SERVICE: '/menu-servicos',
  MANAGE_CIFA: '/menu-cifas',
  CIFA: '/cifa',
  CIFA2025: '/cifa-2025',
  INCLUDE_CIFA_2025: '/cifa-2025/cadastrar/ater',
  VIEW_CIFA_2025: '/cifa-2025/visualizar/ater',
  EDIT_CIFA_2025: '/cifa-2025/editar/ater',
  CREATE_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-federal',
  VIEW_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-federal',
  EDIT_FEDERAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-federal',
  CREATE_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-estadual',
  VIEW_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-estadual',
  EDIT_STATE_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-estadual',
  CREATE_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/cadastrar/alimentacao-escolar-municipal',
  CREATE_CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/cadastrar/confirmar-dados',
  EDIT_CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/editar/confirmar-dados',
  VIEW_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/visualizar/alimentacao-escolar-municipal',
  EDIT_MUNICIPAL_SCHOOL_FEEDING_2025:
    '/cifa-2025/editar/alimentacao-escolar-municipal',
  CONFIRM_SCHOOL_FEEDING_2025: '/cifa-2025/confirmar-dados',

  CIFA2026: '/cifa-2026',
  INCLUDE_CIFA_2026: '/cifa-2026/cadastrar/ater',
  EDIT_CIFA_2026: '/cifa-2026/editar/ater',
  COMPLIANCE_TERM_2026: '/cifa-2026/cadastrar/compliance-term',
  TECH_ASSIST_2026: '/cifa-2026/cadastrar/tech-assist',
  SCHOOL_FEEDING_ACQUISITIONS_2026: '/cifa-2026/cadastrar/school-feeding-acquisitions',
  FINANCIAL_RESOURCE_2026: '/cifa-2026/cadastrar/financial-resource',
  SCHOOL_FEEDING_2026: '/cifa-2026/cadastrar/school-feeding',

  VIEW_CIFA_2026: '/cifa-2026/visualizar/ater',
  VIEW_COMPLIANCE_TERM_2026: '/cifa-2026/visualizar/compliance-term',
  VIEW_TECH_ASSIST_2026: '/cifa-2026/visualizar/tech-assist',
  VIEW_SCHOOL_FEEDING_ACQUISITIONS_2026: '/cifa-2026/visualizar/school-feeding-acquisitions',
  VIEW_FINANCIAL_RESOURCE_2026: '/cifa-2026/visualizar/financial-resource',
  VIEW_SCHOOL_FEEDING_2026: '/cifa-2026/visualizar/school-feeding',

  CIFA2027: '/cifa-2027',
  INCLUDE_CIFA_2027: '/cifa-2027/cadastrar/ater',
  EDIT_CIFA_2027: '/cifa-2027/editar/ater',
  COMPLIANCE_TERM_2027: '/cifa-2027/cadastrar/compliance-term',
  TECH_ASSIST_2027: '/cifa-2027/cadastrar/tech-assist',
  SCHOOL_FEEDING_ACQUISITIONS_2027: '/cifa-2027/cadastrar/school-feeding-acquisitions',
  FINANCIAL_RESOURCE_2027: '/cifa-2027/cadastrar/financial-resource',
  SCHOOL_FEEDING_2027: '/cifa-2027/cadastrar/school-feeding',

  VIEW_CIFA_2027: '/cifa-2027/visualizar/ater',
  VIEW_COMPLIANCE_TERM_2027: '/cifa-2027/visualizar/compliance-term',
  VIEW_TECH_ASSIST_2027: '/cifa-2027/visualizar/tech-assist',
  VIEW_SCHOOL_FEEDING_ACQUISITIONS_2027: '/cifa-2027/visualizar/school-feeding-acquisitions',
  VIEW_FINANCIAL_RESOURCE_2027: '/cifa-2027/visualizar/financial-resource',
  VIEW_SCHOOL_FEEDING_2027: '/cifa-2027/visualizar/school-feeding',

  FIRSTUSER: '/first-user',
  FIRSTUSERCREATE: '/first-user/cadastrar',
  FIRSTUSERSTEPS: '/primeiro-usuario/cadastrar',

  TERMOFADHESION: '/termo-de-adesao',
  REGISTERTERMOFADHESION: '/termo-de-adesao/cadastrar',
  VIEWTERMSADHESION: '/termo-de-adesao/visualizar/:uuid',
  VALIDATETERMSADHESION: '/termo-de-adesao/validar/:uuid',
  EDITTETERMSADHESION: '/termo-de-adesao/editar/:uuid',

  // Pacote de formulários
  PACOTE_FORMULARIOS: '/pacote-de-formularios',
  PACOTE_FORMULARIOS_ID: '/pacote-de-formularios/:uuid',

  // Pacote de formulários - CMDRDS
  PACOTE_FORMULARIOS_CMDRS_EDITAR:
    '/pacote-de-formularios/cmdrs/editar/:uuid',
  PACOTE_FORMULARIOS_VISUALIZAR_EDITAR:
    '/pacote-de-formularios/cmdrs/visualizar/:uuid',

  // Pacote de formulários - CMDRDS
  PACOTE_FORMULARIOS_SIM_EDITAR:
    '/pacote-de-formularios/sim/editar/:uuid',
  PACOTE_FORMULARIOS_SIM_VISUALIZAR:
    '/pacote-de-formularios/sim/visualizar/:uuid',

  // Pacote de formulários - Secretaria Municipal de Agricultura
  PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_VISUALIZAR:
    '/pacote-de-formularios/secretaria_municipal_agricultura/visualizar/:uuid',
  PACOTE_FORMULARIOS_AGRICULTURA_FAMILIAR_EDITAR:
    '/pacote-de-formularios/secretaria_municipal_agricultura/editar/:uuid',

  // Pacote de formulários - Politica Municipal da Agricultura Familiar
  PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_VISUALIZAR:
    '/pacote-de-formularios/politica_municipal_agricultura_familiar/visualizar/:uuid',
  PACOTE_FORMULARIOS_POLITICA_MUNICIPAL_AGRICULTURA_FAMILIAR_EDITAR:
    '/pacote-de-formularios/politica_municipal_agricultura_familiar/editar/:uuid',

  // Pacote de formulários - Politica Municipal da Agricultura Familiar
  PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_VISUALIZAR:
    '/pacote-de-formularios/comunidades_rurais_tradicionais/visualizar/:uuid',
  PACOTE_FORMULARIOS_COMUNIDADES_RURAIS_TRADICIONAIS_EDITAR:
    '/pacote-de-formularios/comunidades_rurais_tradicionais/editar/:uuid',

  // Pacote de formulários - Questões Ambientais
  PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_VISUALIZAR:
    '/pacote-de-formularios/questoes_ambientais/visualizar/:uuid',
  PACOTE_FORMULARIOS_QUESTOES_AMBIENTAIS_EDITAR:
    '/pacote-de-formularios/questoes_ambientais/editar/:uuid',

  // Formulário Comunidades Rurais Tradicionais
  COMUNIDADES_RURAIS_TRADICIONAIS: '/comunidades-rurais-tradicionais',
  COMUNIDADES_RURAIS_TRADICIONAIS_STEPS: '/comunidades-rurais-tradicionais/steps',

  DADOS_GERAIS_CICAAF: '/cicaaf/coleta/dados-gerais/:uuid',

  PRODUCAO_COMERCIALIZACAO_CICAAF: '/cicaaf/production-comercialization/:uuid',

  PRODUTOS_PROCESSADOS_CICAAF: '/cicaaf/processed-products/:uuid',

  INFORMAR_DIFICULDADES_CICAAF: '/cicaaf/coleta/informar-dificuldades/:uuid',

  GERENCIAMENTO_COLETAS_CICAAF: '/cicaaf/gerenciamento-coletas',

  GERENCIAMENTO_COLETAS_CICAAF_VISUALIZAR: '/cicaaf/gerenciamento-coletas/visualizar/:uuid',

  GERENCIAMENTO_COLETAS_CICAAF_EDITAR: '/cicaaf/gerenciamento-coletas/editar/:uuid',

  COLETA_CICAAF: '/cicaaf/coleta',

  IDENTIFICACAO_FAMILIAR_CUFFA_INCLUIR: '/cuffa/identificacao-familiar/incluir',

  IDENTIFICACAO_FAMILIAR_CUFFA_EDITAR: '/cuffa/identificacao-familiar/editar/:uuid',

  IDENTIFICACAO_FAMILIAR_CUFFA_VISUALIZAR: '/cuffa/identificacao-familiar/visualizar/:uuid',

  VISITAS_INSTITUICOES_CUFFA_INCLUIR: '/cuffa/visitas-instituicoes/incluir/:uuid',

  VISITAS_INSTITUICOES_CUFFA_VISUALIZAR: '/cuffa/visitas-instituicoes/visualizar/:uuid',

  CATEGORIA_FUNDIARIA_INCLUIR: '/cuffa/categoria_fundiaria/incluir/:uuid',

  CATEGORIA_FUNDIARIA_VISUALIZAR: '/cuffa/categoria_fundiaria/visualizar/:uuid',

  CADASTRAR_PRODUTOS_INCLUIR: '/cuffa/cadastrar_produtos/incluir/:uuid',

  CADASTRAR_PRODUTOS_VISUALIZAR: '/cuffa/cadastrar_produtos/visualizar/:uuid',

  PRODUCAO_AGROECOLOGICA_INCLUIR: '/cuffa/producao-agroecologica/incluir/:uuid',

  PRODUCAO_AGROECOLOGICA_VISUALIZAR: '/cuffa/producao-agroecologica/visualizar/:uuid',

  DETALHES_PRODUCAO_INCLUIR: '/cuffa/detalhes-producao/incluir/:uuid',

  DETALHES_PRODUCAO_VISUALIZAR: '/cuffa/detalhes-producao/visualizar/:uuid',

  PRODUTOS_PROCESSADOS_INCLUIR: '/cuffa/produtos-processados/incluir/:uuid',

  PRODUTOS_PROCESSADOS_VISUALIZAR: '/cuffa/produtos-processados/visualizar/:uuid',

  INSPECAO_PRODUTOS_CUFFA_INCLUIR: '/cuffa/inspecao-produtos/incluir/:uuid',

  INSPECAO_PRODUTOS_CUFFA_VISUALIZAR: '/cuffa/inspecao-produtos/visualizar/:uuid',

  SELOS_AGREGACAO_CUFFA_INCLUIR: '/cuffa/selos-agregacao/incluir/:uuid',

  SELOS_AGREGACAO_CUFFA_VISUALIZAR: '/cuffa/selos-agregacao/visualizar/:uuid',

  CANAIS_COMERCIALIZACAO_CUFFA_INCLUIR: '/cuffa/canais-comercializacao/incluir/:uuid',

  CANAIS_COMERCIALIZACAO_CUFFA_VISUALIZAR: '/cuffa/canais-comercializacao/visualizar/:uuid',

  CREDITO_FINANCIAMENTO_CUFFA_INCLUIR: '/cuffa/credito-financiamento/incluir/:uuid',

  CREDITO_FINANCIAMENTO_CUFFA_VISUALIZAR: '/cuffa/credito-financiamento/visualizar/:uuid',

  FONTES_RENDA_FAMILIA_CUFFA_INCLUIR: '/cuffa/fontes-renda-familia/incluir/:uuid',

  FONTES_RENDA_FAMILIA_CUFFA_VISUALIZAR: '/cuffa/fontes-renda-familia/visualizar/:uuid',

  PARTICIPACAO_FEMININA_CUFFA_INCLUIR: '/cuffa/participacao-feminina/incluir/:uuid',

  PARTICIPACAO_FEMININA_CUFFA_VISUALIZAR: '/cuffa/participacao-feminina/visualizar/:uuid',

  DIFICULDADES_PRODUCAO_CUFFA_INCLUIR: '/cuffa/dificuldades-producao/incluir/:uuid',

  DIFICULDADES_PRODUCAO_CUFFA_VISUALIZAR: '/cuffa/dificuldades-producao/visualizar/:uuid',

  LISTAR_CUFFA: '/cuffa/listar',

  CUFFA_ASSINATURA_INCLUIR: '/cuffa/assinatura/incluir/:uuid',

  CUFFA_ASSINATURA_VISUALIZAR: '/cuffa/assinatura/visualizar/:uuid',
};
